/* eslint-disable */

$(".js-pricing-slider-container").each(function (index) {
    var container = $(this),
        slider = container.find(".js-pricing-slider"),
        prev_arrow = container.find(".js-pricing-prev-arrow"),
        next_arrow = container.find(".js-pricing-next-arrow");

    slider.slick({
        slidesToShow: 3,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: prev_arrow,
        nextArrow: next_arrow,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
});



// WEBPACK FOOTER //
// ./scripts/partials/pricing-slider.js